module.exports = __webpack_public_path__ + "static/media/16pic.aa5c884d.jpg";